/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
    /* 01.General */
    'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

    /* 02.User Login, Logout, Register */
    'user.login-title': 'Anmeldung',
    'user.register': 'Registrieren',
    'user.forgot-password': 'Passwort vergessen',
    'user.email': 'Email',
    'user.newpassword': 'Neues Passwort',
    'user.currentpassword': 'Jetziges Passwort',
    'user.newpasswordagain': 'Neues Passwort nochmal',
    'user.password': 'Passwort',
    'user.forgot-password-question': 'Vergessen Passwort?',
    'user.fullname': 'Vollständiger Name',
    'user.firstname': 'Vorname',
    'user.lastname': 'Nachname',
    'user.login-button': 'ANMELDUNG',
    'user.register-button': 'REGISTRIEREN',
    'user.reset-password-button': 'ZURÜCKSETZEN',
    'user.buy': 'KAUFEN',
    'user.username': 'Nutzername',

    /* 03.Menu */
    'menu.app': 'Heim',


    'menu.default': 'Ursprünglich',
    'menu.analytics': 'Analytik',
    'menu.ecommerce': 'E-Commerce',
    'menu.content': 'Inhalt',
    'menu.pages': 'Seiten',
    'menu.data-list': 'Datenliste',
    'menu.thumb-list': 'Daumenliste',
    'menu.image-list': 'Image List',
    'menu.details': 'Details',
    'menu.search': 'Search',
    'menu.login': 'Login',
    'menu.register': 'Register',
    'menu.forgot-password': 'Forgot Password',
    'menu.error': 'Error',
    'menu.applications': 'Applications',
    'menu.todo': 'To-do List',
    'menu.survey': 'Survey',
    'menu.chat': 'Chat',
    'menu.ui': 'UI',
    'menu.edit': 'Edit',
    'menu.alerts': 'Alerts',
    'menu.badges': 'Badges',
    'menu.buttons': 'Buttons',
    'menu.cards': 'Cards',
    'menu.carousel': 'Carousel',
    'menu.charts': 'Charts',
    'menu.collapse': 'Collapse',
    'menu.dropdowns': 'Dropdowns',
    'menu.editors': 'Editors',
    'menu.form-layouts': 'Form Layouts',
    'menu.form-components': 'Form Components',
    'menu.form-validations': 'Form Validations',
    'menu.icons': 'Icons',
    'menu.input-groups': 'Input Groups',
    'menu.jumbotron': 'Jumbotron',
    'menu.modal': 'Modal',
    'menu.navigation': 'Navigation',
    'menu.popover-tooltip': 'Popover & Tooltip',
    'menu.sortable': 'Sortable',
    'menu.tables': 'Tables',
    'menu.menu': 'Menu',
    'menu.subhidden': 'Subhidden',
    'menu.hidden': 'Hidden',
    'menu.visible': 'Visible',
    'menu.maps': 'Maps',
    'menu.landingpage': 'Landing Page',
    'menu.multipage-home': 'Multipage Home',
    'menu.singlepage-home': 'Singlepage Home',
    'menu.about': 'About',
    'menu.auth-login': 'Auth Login',
    'menu.auth-register': 'Auth Register',
    'menu.blog': 'Blog',
    'menu.blog-detail': 'Blog Detail',
    'menu.careers': 'Careers',
    'menu.confirmation': 'Confirmation',
    'menu.contact': 'Contact',
    'menu.docs': 'Docs',
    'menu.features': 'Features',
    'menu.prices': 'Prices',
    'menu.videos': 'Videos',
    'menu.mailing': 'Mailing',
    'menu.invoice': 'Invoice',
    'menu.blank-page': 'Coming soon...',
    'menu.types': 'Menu Types',
    'menu.levels': 'Menu Levels',
    'menu.third-level-1': 'Third Level 1',
    'menu.third-level-2': 'Third Level 2',
    'menu.third-level-3': 'Third Level 3',

    /* 04.Dashboards */
    'dashboards.pending-orders': 'Ausstehend Aufträge',
    'dashboards.completed-orders': 'Abgeschlossen Aufträge',
    'dashboards.refund-requests': 'Erstattung Anfragen',
    'dashboards.new-comments': 'Neue Kommentare',
    'dashboards.sales': 'Verkauf',
    'dashboards.orders': 'Aufträge',
    'dashboards.refunds': 'Rückerstattungen',
    'dashboards.recent-orders': 'Jüngste Aufträge',
    'dashboards.product-categories': 'Produkt Kategorien',
    'dashboards.cakes': 'Kuchen',
    'dashboards.tickets': 'Eintrittskarten',
    'dashboards.calendar': 'Kalender',
    'dashboards.best-sellers': 'Bestseller',
    'dashboards.per-session': 'Pro Sitzung',
    'dashboards.profile-status': 'Profile Status',
    'dashboards.payment-status': 'Zahlung Status',
    'dashboards.work-progress': 'Arbeit Fortschritt',
    'dashboards.tasks-completed': 'Aufgaben Abgeschlossen',
    'dashboards.payments-done': 'Zahlungen Fertig',
    'dashboards.order-stock': 'Befehl - Aktie',
    'dashboards.categories': 'Kategorien',
    'dashboards.quick-post': 'Schnell Post',
    'dashboards.title': 'Titel',
    'dashboards.content': 'Inhalt',
    'dashboards.category': 'Kategorie',
    'dashboards.save-and-publish': 'Speichern und Veröffentlichen',
    'dashboards.top-viewed-posts': 'Meistgesehene Beiträge',
    'dashboards.posts': 'Beiträge',
    'dashboards.pending-for-publish': 'Wartet auf Veröffentlichen',
    'dashboards.users': 'Benutzerin',
    'dashboards.on-approval-process': 'Beim Zulassungsverfahren',
    'dashboards.alerts': 'Warnungen',
    'dashboards.waiting-for-notice': 'Warten auf Benachrichtigung',
    'dashboards.files': 'Dateien',
    'dashboards.pending-for-print': 'Wartet auf drucken',
    'dashboards.logs': 'Protokolle',
    'dashboards.gogo': 'GOGO',
    'dashboards.magic-is-in-the-details': 'DIE MAGIE LIEGT IM DETAIL',
    'dashboards.yes-it-is-indeed': 'Ja, das ist es in der Tat!',
    'dashboards.advanced-search': 'Erweiterte Suche',
    'dashboards.toppings': 'Beläge',
    'dashboards.type': 'Typ',
    'dashboards.keyword': 'Stichwort',
    'dashboards.search': 'Suche',
    'dashboards.top-rated-items': 'Bestbewertete Artikel',
    'dashboards.topic': 'Thema',
    /* 05.Pages */
    'pages.title.dashboards.analytics': 'Analytik',
    'pages.title.ari': 'Availability and Rates',
    'pages.title.conversations': 'Conversations',
    'pages.title.bookings': 'Reservierungen und Buchungen',
    'pages.title.tickets': 'Leads und Tickets',
    'pages.title.propinfo': 'Antworten',
    'pages.title.discounts': 'Rabatte und Aktionen',
    'pages.title.finance': 'Finanzen',
    'pages.title.integration': 'Integration',
    'pages.title.admin': 'Administratorin',
    'pages.add-new': 'NEUE HINZUFÜGEN',
    'pages.add-new-modal-title': 'Neues Element hinzufügen',
    'pages.display-options': 'Anzeigeoptionen',
    'pages.orderby': 'Sortieren nach : ',
    'pages.product-name': 'Produktname',
    'pages.category': 'Kategorie',
    'pages.description': 'Beschreibung',
    'pages.status': 'Status',
    'pages.cancel': 'Absagen',
    'pages.submit': 'Einreichen',
    'pages.delete': 'Löschen',
    'pages.another-action': 'Eine weitere Aktion',
    'pages.actions': 'AKTIONEN',
    'pages.header': 'Header',
    'pages.details': 'EINZELHEITEN',
    'pages.orders': 'AUFTRÄGE',
    'pages.rating': 'Bewertung',
    'pages.price': 'Preis',
    'pages.ingredients': 'Zutaten',
    'pages.is-vegan': 'Is Vegan',
    'pages.order-status': 'Order Status',
    'pages.bake-progress': 'Bake Progress',
    'pages.popularity': 'Popularity',
    'pages.comments': 'Comments',
    'pages.error-title': 'Ups... sieht aus, als wäre ein Fehler aufgetreten!',
    'pages.error-code': 'Fehlercode',
    'pages.go-back-home': 'WIEDER NACH HAUSE GEHEN',
    'pages.mailing-info':
        'Mailing-Vorlagen verwenden Inline-Styling und Tabellenlayout, um bei verschiedenen Dienstleistern gut angezeigt zu werden. Um eine bessere Benutzerfreundlichkeit zu bieten, fügen wir es als reguläres HTML mit DangerlySetInnerHTML ein.',
    'pages.invoice-info':
        'Die Rechnungsvorlage hat eine Inline-Version zur Verwendung außerhalb des Projekts sowie eine React-Version.',
    'pages.react-version': 'React Version',
    'pages.inline-version': 'Inline Styled Html Version',

    /* 06.Applications */

    /* 06.01.Chat */
    'chat.messages': 'Mitteilungen',
    'chat.contacts': 'Kontakte',
    'chat.saysomething': 'Sag etwas..',

    /* 06.02.Survey */
    'survey.delete': 'Löschen',
    'survey.edit': 'Bearbeiten',
    'survey.add-new': 'NEUE HINZUFÜGEN',
    'survey.add-new-title': 'Neue Umfrage hinzufügen',
    'survey.title': 'Titel',
    'survey.category': 'Kategorie',
    'survey.label': 'Etikett',
    'survey.status': 'Status',
    'survey.cancel': 'Absagen',
    'survey.submit': 'Einreichen',
    'survey.another-action': 'Eine weitere Aktion',
    'survey.display-options': 'Anzeigeoptionen',
    'survey.orderby': 'Sortieren nach : ',
    'survey.all-surveys': 'Alle Umfragen',
    'survey.completed-surveys': 'Abgeschlossene Umfragen',
    'survey.categories': 'Kategorien',
    'survey.active-surveys': 'Aktive Umfragen',
    'survey.labels': 'Etiketten',

    /* 06.03.Todo */
    'todo.add-new': 'NEUE HINZUFÜGEN',
    'todo.add-new-title': 'Neues Todo hinzufügen',
    'todo.title': 'Titel',
    'todo.detail': 'Einzelheit',
    'todo.category': 'Kategorie',
    'todo.label': 'Etikett',
    'todo.status': 'Status',
    'todo.cancel': 'Absagen',
    'todo.submit': 'Einreichen',
    'todo.action': 'Aktion',
    'todo.another-action': 'Eine weitere Aktion',
    'todo.display-options': 'Anzeigeoptionen',
    'todo.orderby': 'Sortieren nach : ',
    'todo.all-tasks': 'Alle Aufgaben',
    'todo.pending-tasks': 'Ausstehende Aufgaben',
    'todo.completed-tasks': 'Abgeschlossene Aufgaben',
    'todo.categories': 'Kategorien',
    'todo.labels': 'Etiketten',

    /* 07.UI */

    /* 07.01.Alerts */
    'alert.rounded': 'Rounded Alert',
    'alert.react-notifications': 'React Notifications',
    'alert.outline': 'Outline',
    'alert.primary': 'Primary',
    'alert.secondary': 'Secondary',
    'alert.info': 'Info',
    'alert.success': 'Success',
    'alert.warning': 'Warning',
    'alert.error': 'Error',
    'alert.filled': 'Filled',
    'alert.primary-text': 'This is a primary alert—check it out!',
    'alert.secondary-text': 'This is a secondary alert—check it out!',
    'alert.success-text': 'This is a success alert—check it out!',
    'alert.danger-text': 'This is a danger alert—check it out!',
    'alert.warning-text': 'This is a warning alert—check it out!',
    'alert.info-text': 'This is a info alert—check it out!',
    'alert.light-text': 'This is a light alert—check it out!',
    'alert.dark-text': 'This is a dark alert—check it out!',
    'alert.default': 'Default Alert',
    'alert.dismissing': 'Dismissing Alert',
    'alert.dismissing-text':
        'Holy guacamole! You should check in on some of those fields below.',
    'alert.dismissing-without-animate-text':
        'I am an alert and I can be dismissed without animating!',

    /* 07.02.Badges */
    'badge.sizes': 'Sizes',
    'badge.colors': 'Colors',
    'badge.outline': 'Outline',
    'badge.links': 'Links',
    'badge.counter-badges': 'Counter Badges',
    'badge.bootstrap-default': 'Bootstrap Default',
    'badge.primary': 'Primary',
    'badge.secondary': 'Secondary',
    'badge.success': 'Success',
    'badge.danger': 'Danger',
    'badge.warning': 'Warning',
    'badge.info': 'Info',
    'badge.light': 'Light',
    'badge.dark': 'Dark',

    /* 07.03.Buttons */
    'button.default': 'Bootstrap Default',
    'button.colors': 'Colors',
    'button.rounded': 'Rounded',
    'button.outline': 'Outline',
    'button.states': 'States',
    'button.sizes': 'Sizes',
    'button.button-groups': 'Button Groups',
    'button.large-button': 'Large Button',
    'button.small-button': 'Small Button',
    'button.extra-small-button': 'Extra Small Button',
    'button.block-button': 'Block Button',
    'button.active': 'Active',
    'button.disabled': 'Disabled',
    'button.basic': 'Basic',
    'button.toolbar': 'Toolbar',
    'button.nesting': 'Nesting',
    'button.vertical-variation': 'Vertical Variation',
    'button.checkbox-radio-button': 'Checkbox and Radio Button',
    'button.checkbox': 'Checkbox',
    'button.radio': 'Radio',
    'button.radio-button': 'Radio Button',
    'button.primary': 'Primary',
    'button.secondary': 'Secondary',
    'button.success': 'Success',
    'button.danger': 'Danger',
    'button.warning': 'Warning',
    'button.info': 'Info',
    'button.light': 'Light',
    'button.dark': 'Dark',
    'button.states-text':
        'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
    'button.click-here': 'Click Here',
    'button.states-text-alternate':
        'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
    'button.primary-link': 'Primary Link',
    'button.link': 'Link',
    'button.primary-button': 'Primary Button',
    'button.button': 'Button',
    'button.left': 'Left',
    'button.middle': 'Middle',
    'button.right': 'Right',
    'button.dropdown': 'Dropdown',
    'button.dropdown-link': 'Dropdown Link',

    /* 07.04.Cards */
    'cards.icon-card': 'Icon Card',
    'cards.image-card': 'Image Card',
    'cards.image-overlay-card': 'Image Overlay Card',
    'cards.image-card-list': 'Image Card List',
    'cards.tab-card': 'Tab Card',
    'cards.user-card': 'User Card',

    /* 07.05.Carousel */
    'carousel.basic': 'Carousel Basic',
    'carousel.single': 'Carousel Single',
    'carousel.without-controls': 'Carousel Without Controls',

    /* 07.06.Charts */
    'charts.line': 'Line Chart',
    'charts.polar': 'Polar Chart',
    'charts.area': 'Area Chart',
    'charts.scatter': 'Scatter Chart',
    'charts.bar': 'Bar Chart',
    'charts.radar': 'Radar Chart',
    'charts.pie': 'Pie Chart',
    'charts.doughnut': 'Doughnut Chart',
    'charts.shadow': 'Shadow',
    'charts.no-shadow': 'No Shadow',

    /* 07.07.Collapse */
    'collapse.basic': 'Basic',
    'collapse.toggle': 'Toggle',
    'collapse.accordion': 'Accordion',
    'collapse.controlled': 'Controlled',
    'collapse.uncontrolled': 'Uncontrolled',

    /* 07.08.Dropdowns */
    'dropdowns.basic': 'Basic',
    'dropdowns.controlled': 'Controlled',
    'dropdowns.uncontrolled': 'Uncontrolled',
    'dropdowns.dropdown': 'Dropdown',
    'dropdowns.header': 'Header',
    'dropdowns.action': 'Action',
    'dropdowns.another-action': 'Another Action',
    'dropdowns.right': 'Right',
    'dropdowns.left': 'Left',
    'dropdowns.drop-directions': 'Drop Directions',
    'dropdowns.dropright': 'Dropright',
    'dropdowns.dropleft': 'Dropleft',
    'dropdowns.small-button': 'Small Button',
    'dropdowns.large-button': 'Large Button',
    'dropdowns.sizing': 'Sizing',
    'dropdowns.split-button': 'Split Button Dropdowns',
    'dropdowns.dropup': 'Dropup',

    /* 07.09.Editors */
    'editors.draftjs': 'Draft.js',
    'editors.quill-standart': 'Quill Standard',
    'editors.quill-bubble': 'Quill Bubble',

    /* 07.10.Forms */
    'forms.basic': 'Basic',
    'forms.email': 'E-mail',
    'forms.email-muted': "We'll never share your email with anyone else.",
    'forms.password': 'Password',
    'forms.submit': 'Einreichen',
    'forms.horizontal': 'Horizontal',
    'forms.radios': 'Radios',
    'forms.first-radio': 'First radio',
    'forms.second-radio': 'Second radio',
    'forms.third-radio-disabled': 'Third disabled radio',
    'forms.checkbox': 'Checkbox',
    'forms.signin': 'Sign in',
    'forms.top-labels-over-line': 'Top Labels Over Line',
    'forms.tags': 'Tags',
    'forms.date': 'Date',
    'forms.state': 'State',
    'forms.top-labels-in-input': 'Top Labels In Input',
    'forms.email-u': 'E-MAIL',
    'forms.password-u': 'PASSWORD',
    'forms.tags-u': 'TAGS',
    'forms.date-u': 'DATE',
    'forms.state-u': 'STATE',
    'forms.grid': 'Form Grid',
    'forms.address': 'Address',
    'forms.address2': 'Address 2',
    'forms.city': 'City',
    'forms.city-message': 'Please select a city!',
    'forms.state-message': 'Please select a state!',
    'forms.zip': 'Zip',
    'forms.signup': 'Signup',
    'forms.inline': 'Inline',
    'forms.validation-availity': 'Availity Reactstrap Validation',
    'forms.validation-formik': 'Formik Validation',
    'forms.default': 'Default',
    'forms.firstname': 'First name',
    'forms.firstname-message': 'Please enter your first name!',
    'forms.lastname': 'Last name',
    'forms.lastname-message': 'Please enter your last name!',

    /* 07.11.Form Components */
    'form-components.custom-inputs': 'Custom Inputs',
    'form-components.checkboxes': 'Checkboxes',
    'form-components.radios': 'Radios',
    'form-components.inline': 'Inline',
    'form-components.react-select': 'React Select',
    'form-components.state-single': 'State Single',
    'form-components.state-multiple': 'State Multiple',
    'form-components.react-autosuggest': 'React Autosuggest',
    'form-components.date-picker': 'Date Picker',
    'form-components.date': 'Date',
    'form-components.date-range': 'Date Range',
    'form-components.date-with-time': 'Date with Time',
    'form-components.embedded': 'Embedded',
    'form-components.dropzone': 'Dropzone',
    'form-components.drop-files-here': 'Drop Files Here',
    'form-components.tags': 'Tags',
    'form-components.switch': 'Switch',
    'form-components.primary': 'Primary',
    'form-components.secondary': 'Secondary',
    'form-components.primary-inverse': 'Primary Inverse',
    'form-components.secondary-inverse': 'Secondary Inverse',
    'form-components.slider': 'Slider',
    'form-components.double-slider': 'Double Slider',
    'form-components.single-slider': 'Single Slider',
    'form-components.rating': 'Rating',
    'form-components.interactive': 'Interactive',
    'form-components.readonly': 'Readonly',
    'form-components.type-a-cake': 'Type a Cake',
    'form-components.start': 'Start',
    'form-components.end': 'End',
    'form-components.tables': 'Tables',
    /* 07.12.Icons */
    'icons.simplelineicons': 'Simple Line Icons',
    'icons.iconsmind': 'Iconsmind Icons',

    /* 07.13.Input Groups */
    'input-groups.basic': 'Basic',
    'input-groups.sizing': 'Sizing',
    'input-groups.small': 'Small',
    'input-groups.default': 'Default',
    'input-groups.large': 'Large',
    'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
    'input-groups.multiple-inputs': 'Multiple Inputs',
    'input-groups.first-and-last-name': 'First and last name',
    'input-groups.multiple-addons': 'Multiple Addons',
    'input-groups.button-addons': 'Button Addons',
    'input-groups.button': 'Button',
    'input-groups.buttons-with-dropdowns': 'Schaltflächen mit Dropdowns',
    'input-groups.dropdown': 'Dropdown',
    'input-groups.header': 'Header',
    'input-groups.action': 'Aktion',
    'input-groups.another-action': 'Eine weitere Aktion',
    'input-groups.custom-select': 'Benutzerdefinierte Auswahl',
    'input-groups.options': 'Optionen',
    'input-groups.choose': 'Wählen...',
    'input-groups.custom-file-input': 'Benutzerdefinierte Dateieingabe',

    /* 07.14.Jumbotron */
    'jumbotron.hello-world': 'Hallo Welt!',
    'jumbotron.lead':
        'Dies ist eine einfache Heldeneinheit, eine einfache Komponente im Jumbotron-Stil, um besondere Aufmerksamkeit auf bestimmte Inhalte oder Informationen zu lenken.',
    'jumbotron.lead-detail':
        'Es verwendet Hilfsklassen für Typografie und Abstände, um Inhalte innerhalb des größeren Containers zu verteilen.',
    'jumbotron.learn-more': 'Mehr erfahren',

    /* 07.15.Modal */
    'modal.basic': 'Basic',
    'modal.modal-title': 'Modaler Titel',
    'modal.launch-demo-modal': 'Demo-Modal starten',
    'modal.scrolling-long-content': 'Scrollen von langem Inhalt',
    'modal.backdrop': 'Hintergrund',
    'modal.backdrop-value': 'Hintergrundwert',
    'modal.right-modal': 'Rechtes Modal',
    'modal.launch-right-modal': 'Starten Sie Right Modal',
    'modal.nested-modal': 'Verschachteltes Modal',
    'modal.size': 'Größe',
    'modal.launch-large-modal': 'Starten Sie Large Modal',
    'modal.launch-small-modal': 'Starten Sie Small Modal',

    /* 07.16.Navigation */
    'nav.basic': 'Navi Basic',
    'nav.active': 'Aktiv',
    'nav.disabled': 'Deaktiviert',
    'nav.disabled-link': 'Link deaktiviert',
    'nav.link': 'Verknüpfung',
    'nav.longer-link': 'Länger Nav Verknüpfung',
    'nav.another-link': 'Ein weiterer Link',
    'nav.right': 'Recht',
    'nav.dropdown': 'Dropdown',
    'nav.header': 'Kopfzeilen',
    'nav.action': 'Aktion',
    'nav.another-action': 'Eine weitere Aktion',
    'nav.horizontal-alignment': 'Nav Horizontale Ausrichtung',
    'nav.vertical-alignment': 'Nav Vertikale Ausrichtung',
    'nav.pills': 'Nav Pillen',
    'nav.fill-justify': 'Nav Füllen und Rechtfertigen',
    'nav.pills-dropdowns': ' Nav Pillen mit Dropdowns',
    'nav.pagination-basic': 'Grundlegende Paginierung',
    'nav.pagination-sizing': 'Paginierungsgröße',
    'nav.large': 'Groß',
    'nav.small': 'Klein',
    'nav.center': 'Center',
    'nav.pagination-alignment': 'Paginierungsausrichtung',
    'nav.breadcrumb-basic': 'Brotkrümel Basic',

    /* 07.17.Popover & Tooltip */
    'popover-tooltip.popover': 'Popover',
    'popover-tooltip.tooltip': 'Kurzinfo',

    /* 07.18.Sortable */
    'sortable.columns': 'Spalten sortieren',
    'sortable.basic': 'Basic',
    'sortable.handles': 'Griffe',

    /* 07.19.Maps */
    'maps.google': 'Google',
    'maps.yandex': 'Jandex',

    /* 07.20.Tables */
    'table.bootstrap-tables': 'Bootstrap-Tabellen',
    'table.bootstrap-basic': 'Grundlegende Tabelle',
    'table.bootstrap-striped': 'Gestreift Reihen',
    'table.bootstrap-bordered': 'Eingefasster Tisch',
    'table.bootstrap-borderless': 'Randloser Tisch',
    'table.bootstrap-hoverable': 'Schwebefähig Reihen',
    'table.bootstrap-responsive': 'Responsive Tabelle',
    'table.react-tables': 'Reaktionstabellen',
    'table.react-pagination': 'Seitennummerierung',
    'table.react-scrollable': 'Scrollbar',
    'table.react-advanced': 'Filter, Länge und Springen',

    /* Property Info */
    'property-info.about-property': 'Über Eigentum',
    'property-info.about-properties': 'Über Eigenschaften',
    'property-info.facilities-services': 'Einrichtungen & Dienstleistungen',
    'property-info.property-facilities': 'Eigentum Einrichtungen',
    'property-info.room-amenities': 'Zimmer Ausstattung',
    'property-info.property-contact': 'Eigentum Kontakt',
    'property-info.property-activities': 'Eigentum Aktivitäten',
    'property-info.property-location': 'Eigentum Ort',
    'property-info.about-rooms': 'Über Räume',
    'property-info.about-sites': 'Über Websites',
    'property-info.special-emergencies': 'Notfälle',
    'property-info.gallery': 'Galerie',
    'property-info.policies': 'Richtlinien',
    'property-info.nearby': 'In der Nähe',
    'property-info.transport': 'Transport',
    'property-info.location': 'Ort',
    'property-info.about-rhproperty': 'Um Ruhestand Heim',
    'property-info.related-topics': 'Verwandt Themen',
    'property-info.assistant-options': 'Assistentenmenü',
    'property-info.restaurant-assistant-information': 'Restaurantinformationen',
    'property-info.restaurant-assistant-options': 'Willkommensnachricht',
    'property-info.channel-messages': 'Kanalnachrichten',
    'property-info.icon.gallery': 'Icon-Galerie',
    'property-info.copilot': 'Kopilot',
    'property-info.sprint': 'Sprint',
    'property-info.home-information': 'Home-Informationen',
    'property-info.loction': 'Standorte',
    'property-info.rooms-and-images': 'Räume & Bilder',
    'property-info.trainig-data': 'Trainingsdaten',
    'property-info.flows': 'Fließt',
    'property-info.add-your-own': 'Füge dein eigenes hinzu',
    'property-info-utility-miscellaneous': 'Verschiedenes',
    'property-info-utility-payment': 'Zahlungen',
    'property-info-utility-broadband': 'Breitband',
    'property-info-utility-emergency': 'Notfall',
    'property-info-utility-mobile': 'Handy, Mobiltelefon',
    'property-info-utility-moving': 'Ziehen um',

    /** Rate & Promo */
    'rate-promo.rate-plans': 'Tarifpläne',
    'rate-promo.rate-plan-addons': "Add-Ons",
    'rate-promo.rate-plan-promos': 'Sonderangebote',

    'title.property-information': 'Eigentum Information',

    'property.message': 'Nachricht',
    'property.example': 'Beispiel',
    'property.link': 'Verknüpfungen',
    'property.image-carousel': 'Bildkarussell',
    'property.Title': 'Titel',
    'property.SubTitle': 'Untertitel',

    'property.add-invoke-api': 'API aufrufen',
    'property.add-message-button': 'Hinzufügen Mitteilungen',
    'property.add-img-button': 'Hinzufügen Bilder',
    'property.add-link-button': 'Hinzufügen Verknüpfung',
    'property.add-herocard-button': 'Hinzufügen Heldenkarte',
    'property.add-api-button': 'Hinzufügen Tasten',

    'menu.about-property': 'um Eigentum',
    'menu.property-facilities': 'Eigentum Einrichtungen',
    'menu.room-amenities': 'Zimmer Ausstattung',
    'menu.property-contact': 'Eigentum Kontakt',
    'menu.about-rooms': 'Über Räume',
    'menu.special-emergencies': 'Notfälle',
    'menu.show-filter': 'Filter',
    'menu.new': 'Neu',

    'dashboards.common-asked': 'Häufig gestellte Fragen',
    'dashboards.website-visitor-asking': 'Dinge, nach denen Website-Besucher fragen',
    'dashboards.visit-country': 'Website-Besuch nach Land',
    'dashboards.visit-traffic': 'Land des Website-Verkehrs',
    'dashboards.rooms-product': 'Zimmer & Produkte',
    'dashboards.popular-room-product': 'Beliebte Zimmer und Produkte',

    'dashboards.messenger-stats': 'Beliebte Menüpunkte',
    'dashboards.messenger-stats-topic-view': 'Statistiken zu Menüelementansichten',
    'dashboards.messenger-stats-visits': 'Menüpunktansichten',
    'dashboards.opening-menu-items': 'Anzahl der Website-Besucher, die Menüelemente öffnen',

    'dashboards.number-totalavatarclick': 'Gesamtzahl der Avatar-Klicks',

    'dashboards.clicks': 'Klicks',
    'dashboards.leads': 'Führt',
    'dashboards.hours': 'Std',
    'dashboards.minutes': 'Protokoll',

    'dashboards.ai-chatbot': 'KI-Chatbot',
    'dashboards.compendium': 'Kompendium',
    'dashboards.compendium-digital-usage': 'Nutzung des digitalen Kompendiums',
    'dashboards.compendium-unique-visits': 'Einzigartige Besuche',
    'dashboards.compendium-opening-menu-items': 'Anzahl der angezeigten Menüpunkte',
    'dashboards.compendium-total-digital-clicks': 'Gesamtzahl der Klicks auf das digitale Kompendium',

    'property.delete': 'Löschen',
    'menu.userroles': 'Benutzer & Rollen',
    'menu.ratebookings': 'Preise & Buchungen',
    'dashboards.engagement-time': 'Einsatzzeit des digitalen Assistenten',
    'dashboards.conversations-minutes': 'Gesamtminuten und Gesprächsminuten über Nacht (19:00 bis 7:00 Uhr).',
    'dashboards.visitor-questions': 'Besucherfragen',
    'dashboards.recent-queries': 'Letzte Abfragen',
    'dashboards.visitor-saying': 'Was Ihre Besucher dem digitalen Assistenten sagen',
    'dashboards.contacts-prechatform-leavemessage': 'Gespeicherte Kontakte aus dem Pre-Chat-Formular und Nachricht hinterlassen',
    'menu.dashboards': 'Einblicke',
    'menu.ari': 'Verfügbarkeit & Preise',
    'menu.conversations': 'Gespräche',
    'menu.conversations.unified-inbox': 'Einheitlicher Posteingang',
    'menu.conversations.active': 'Aktive Chats',
    'menu.conversations.archives': 'Archiv',
    'menu.conversations.missed-responses': 'Verpasste Antworten',
    'menu.conversations.ticket': 'Tickets',
    'menu.conversations.reply-templates': 'Antwortvorlagen',
    'menu.bookings': 'Reservierungen & Buchungen',
    'menu.tickets': 'Führt & Eintrittskarten',
    'menu.propinfo': 'Wissen Nabe',
    'menu.rate-promos': 'Preise & Werbeaktionen',
    'menu.finance': 'Finanzen',
    'menu.integration': 'Verbinden',
    'menu.admin': 'Verwaltung & Sicherheit',
    'menu.favourites': 'Favoriten',
    'menu.recommender': 'Gesprächsfluss',
    'menu.assistant-setup': 'Assistenten-Setup',
    'menu.admin-insights': 'Admin-Einblicke',
    'menu.super-admin': 'Super Admin',
    'menu.groups': 'Gruppen',
    'menu.properties': 'Eigenschaften',
    'menu.service-provider': 'Dienstleister',
    'menu.spaces': 'Räume',

    'dashboards.space-booking': 'Raumbuchung',
    'dashboards.gift-voucher': 'Geschenkgutscheine',
    'dashboards.chatbots': 'Chatbots',
    'dashboards.form': 'Aus',
    'dashboards.to': 'Zu',
    'dashboards.active-groups': 'Aktive Gruppen',
    'dashboards.active-properties': 'Aktive Eigenschaften',
    'dashboards.live-properties': 'Live-Eigenschaften',
    'dashboards.properties-going': 'Eigenschaften, die nach Datumsbereich live gehen',
    'dashboards.start-date': 'Startdatum',
    'dashboards.end-date': 'Enddatum',

    'dashboards.website-visits': 'Webseite Besuche',
    'dashboards.unique-visitors': 'Einzigartig Besucher',
    'dashboards.last-week': 'Letzte Woche',
    'dashboards.this-week': 'In dieser Woche',
    'dashboards.this-month': 'Diesen Monat',
    'dashboards.previous-month': 'Vorheriger Monat',
    'dashboards.yeartodate': 'Der bisherige Jahresverlauf',
    'dashboards.lastyear': 'Letzte Jahr',
    'dashboards.last-7-days': 'Letzte 7 Tage',
    'dashboards.last-30-days': 'Letzte 30 Tage',
    'dashboards.last-60-days': 'Letzte 60 Tage',
    'dashboards.last-90-days': 'Letzte 90 Tage',
    'dashboards.conversion-rates': 'Umrechnungskurse',
    'dashboards.digital-assistant-engagement': 'Engagement für digitale Assistenten',
    'dashboards.total-overnight-conversations': 'Gesamt- und Übernachtungsgespräche (19:00 bis 7:00 Uhr).',
    'dashboards.percentage-accuracy': 'Genauigkeit verstehen',
    'dashboards.percentage-conversion': 'Umwandlung von Website-Traffic in Chat',
    'dashboards.percentage-avatarclick': 'Website-Traffic zu Avatar-Klicks',
    'dashboards.percentage-negativefeedback': 'Negatives Feedback als Prozentsatz der Avatar-Klicks',
    'dashboards.percentage-amenties': 'Annehmlichkeit Abfragen',
    'dashboards.percentage-booking': 'Buchung Anfragen',
    'dashboards.percentage-webchats': 'Website-Chats',
    'dashboards.percentage-facebookchat': 'Facebook-Chats',
    // 'dashboards.number-webchattime': 'Total Web Chat Time',
    'dashboards.number-webchattime': 'Gesamt Gespräch Zeit',
    'dashboards.number-totalconversation': 'Totale Gespräche',
    'dashboards.number-websiteconversation': 'Website-Gespräche',
    'dashboards.number-facebookconversation': 'Facebook-Gespräche',
    'dashboards.number-estimatedtimesaving': 'Geschätzt Zeit Ersparnisse',
    'dashboards.number-googlemapsconversation': 'Google Maps Gespräche',
    'dashboards.number-whatsappconversation': 'WhatsApp-Gespräche',
    'dashboards.number-instagramconversation': 'Instagram-Gespräche',
    'dashboards.number-agentconversation': 'Agent Gespräche',
    'dashboards.number-amenityqueries': 'Annehmlichkeit Abfragen',
    'dashboards.number-bookingenquiries': 'Buchung Abfragen',
    'dashboards.number-groupbookingenquiries': 'Gruppe Buchung Anfragen',
    'dashboards.number-eventenquiries': 'Vorfall Anfragen',
    'dashboards.number-longstayenquiries': 'Lang Bleibe Anfragen',
    'dashboards.number-totaltickets': 'Eintrittskarten',
    'dashboards.number-returncustomer': 'Zurückkehren Kunde',
    'dashboards.number-redirects': 'Webseite Weiterleitungen',
    'dashboards.number-bookingengineleads': 'Buchungsmaschinen-Leads',
    'dashboards.number-roomnightsreferred': "Übernachtungen bezogen",
    'dashboards.number-revenuereferred': "Einnahmen bezogen",
    'menu.bookingsmenu': 'Buchungen',
    'menu.guests': 'Gäste Information',
    'menu.whatsnew': "Was gibt's Neues",
    'forms.forms-title': 'Form',
    'menu.formbuilder': 'Formularersteller',

    'menu.virtualfrontdesk': 'Virtuelle Rezeption',
    'menu.guestservice': 'Dienstleistungen für die Gäste',
    'virtual-front.common-questions': "Häufige Fragen",
    'virtual-front.add-on-upsells': "Add-Ons und Upsells",
    'virtual-front.service-order': "Serviceauftrag",
    // 'virtual-front.guest-service-add-on-upsells': "Gästeservices und Add-Ons",
    'virtual-front.guest-service-add-on-upsells': "Digitales Gästebuch",
    'virtual-front.outbound': "Ausgehend",
    'virtual-messenger': "Botin",

    'missed-response.missed-response-title': "Titel der verpassten Antwort",
};
